import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { artefactsApi } from "./api/artefacts";
import { queryClient } from "../../shared/providers/QueryProvider";

export const useAddArtefacts = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload }: { payload: any }) => {
            return await artefactsApi.addArtefacts(payload);
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useEditArtefacts = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ artefactId, payload }: { artefactId: string, payload: any }) => {
            return await artefactsApi.editArtefacts(artefactId, payload);
        },
        onSuccess: async () => {
          await qc.refetchQueries({ queryKey: ["artefact-document-state"] });
        },
    });
};

export const useFetchArtefactsDetails = (artefactId: string | null) => {

    const { data, isLoading, isPending, isRefetching, isError, error, refetch } = useQuery({
        queryKey: ["project-artefacts", artefactId],
        queryFn: () => artefactsApi.fetchArtefactsDetails(artefactId),
        enabled: !!artefactId
    });

    return {
        data: data?.data || [], isLoading: isLoading || isPending || isRefetching, isError, error, refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["project-artefacts", artefactId] }); }
    };

};